import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isConfigureProjectToolsRequestFailure() {
      return getState().isFailure;
    },
    isConfigureProjectToolsRequestPending() {
      return getState().isPending;
    },
    isConfigureProjectToolsRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
